/**
 * 云服务类别 产品图表页 导出数据Dialog
 *
 * @format
 */

import React, { useState, useMemo } from 'react'
import { _$, Dialog, Message } from '@king-design/react'
import { TablePage } from 'src/components'
import { IMonitorGraphData } from './constants'
// eslint-disable-next-line max-len
import { aggregator_menu } from 'src/containers/MonitorDashboard/Customboard/EditGraphMetricFormItem'
import { ProductItem } from 'src/utils/interface'
import { request } from 'src/utils'
import Api from 'src/api/ApiDashboard'
interface MonitorChartDeleteProps {
  visible: boolean
  dashboardId: string | number
  graph: IMonitorGraphData
  productList: ProductItem[]
  closeDelete: () => void
  reload: () => void
}

const DeleteInstances: React.FC<{ instances: any[]; productType: number }> = ({
  instances,
  productType
}) => {
  const [num, setNum] = useState<number>(10)
  const instanceSlice = useMemo(() => {
    return instances?.slice(0, num)
  }, [instances, num])

  return (
    <>
      {instanceSlice.map(item => {
        return (
          <>
            <p style={{ margin: 0 }}>{productType === 4 ? item.instanceIP : item.instanceName}</p>
          </>
        )
      }) || ''}
      {instances?.length > num ? (
        <p
          style={{ cursor: 'pointer', margin: '8px 0 0 0', color: '#0091ea' }}
          onClick={() => {
            setNum(num => (num += 10))
          }}
        >
          查看更多（{instanceSlice?.length}/{instances?.length}）
        </p>
      ) : null}
    </>
  )
}

const MonitorChartDelete: React.FC<MonitorChartDeleteProps> = ({
  visible,
  closeDelete,
  dashboardId,
  graph,
  productList,
  reload
}) => {
  // 删除图表 scheme
  const delScheme = {
    productType: {
      title: _$('产品类型'),
      width: 100,
      template: data => {
        const find =
          productList?.length && productList.find(item => item.productType === data.productType)
        return find?.productName || ''
      }
    },
    metricName: {
      title: _$('监控项'),
      width: 100
    },
    instances: {
      title: _$('实例名称'),
      width: 200,
      template: data => {
        return <DeleteInstances instances={data.instances} productType={data.productType} />
      }
    },
    metricTags: {
      title: _$('维度'),
      width: 100,
      template: data => {
        return data.metricTags?.map(item => item) || '-'
      }
    },
    resourceAggregator: {
      title: _$('实例聚合方式'),
      width: 100,
      template: data => {
        return aggregator_menu[data.resourceAggregator] || '-'
      }
    }
  }

  // 删除图表
  const delChart = async () => {
    const result = await request(Api.DeleteDashboardGraph, {
      method: 'POST',
      data: {
        DashboardId: parseInt(dashboardId as string),
        GraphId: graph.graphId
      }
    })
    if (result?.code === 'Success') {
      Message.success('删除成功')
      closeDelete()
      reload && reload()
    }
  }
  return (
    <Dialog
      mode="destroy"
      width={850}
      value={visible}
      onChangeValue={show => {
        !show && closeDelete()
      }}
      title={`确认删除图表${graph.title}吗?`}
      ok={delChart}
    >
      <TablePage
        tableProps={{
          checkType: 'none',
          data: graph.metrics,
          scheme: delScheme
        }}
      ></TablePage>
    </Dialog>
  )
}

export default MonitorChartDelete
